import { Color4, Color3 } from '@babylonjs/core';
export const DEFAULT_RGB_BRIGHTNESS = 0;
export const DEFAULT_RGB_CONTRAST = 0;
export const DEFAULT_RGB_GAMMA = 1;
export const DEFAULT_MAX_POINT_SIZE = 50;
export const DEFAULT_MIN_NODE_PIXEL_SIZE = 50;
export const DEFAULT_MIN_POINT_SIZE = 2;
export const DEFAULT_PICK_WINDOW_SIZE = 15;
// export const DEFAULT_POINT_BUDGET = 1_000_000;
export const DEFAULT_POINT_BUDGET = 10_000_000;
// export const DEFAULT_POINT_BUDGET = 30_000_000;
export const MAX_LOADS_TO_GPU = 2;
export const MAX_NUM_NODES_LOADING = 4;
export const COLOR_BLACK = new Color3(0, 0, 0);
export const DEFAULT_HIGHLIGHT_COLOR = new Color4(1, 0, 0, 1);
